import React, {useEffect, useState} from 'react';
import { Box, Paper } from '@mui/material';
import { keyframes } from '@mui/system';
import SmallLogo from "@/components/logo/inbriefFullWhiteR_small.svg";
import Typography from "@mui/material/Typography";
import {CHAT_FONT} from "../../../constants/styles";

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-5px); }
`;

const dotsDimension = 2

const THINKING_EXPRESSIONS = [
    "Processing your request now",
    "Analyzing the data",
    "Computing the answer",
    "Working on that for you",
    "Running the calculations",
    "Generating your response",
    "Gathering the necessary information",
    "Crunching the numbers",
    "Thinking about this",
    "Reviewing your input",
    "Formulating the best answer",
    "Putting the pieces together",
    "Synthesizing the data",
    "Evaluating the options",
    "Just a moment while I process this",
    "Finalizing the results",
    "Fetching the details",
    "Looking into that right now",
    "Sorting through the information",
    "Organizing the response"
]

export const ThinkingBubble: React.FC = () => {
    const [thinkingText, setThinkingText] = useState<string>("")


    useEffect(() => {
        const randomIndex = Math.ceil(Math.random() * THINKING_EXPRESSIONS.length)
        setThinkingText(THINKING_EXPRESSIONS[randomIndex] ? THINKING_EXPRESSIONS[randomIndex] : "Thinking")
    }, []);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', width: '100%', boxSizing: 'border-box' }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end', gap: 1, maxWidth: '85%', minWidth: 0 }}>

                {/* Avatar Agente */}
                <Box sx={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                    width: 30, height: 30, borderRadius: '50%', flexShrink: 0,
                    backgroundColor: 'transparent',
                    color: 'secondary.contrastText',
                }}>
                    <img src={SmallLogo} width={'22px'} height={'22px'}/>
                </Box>

                {/* Bolla dei tre puntini */}
                <Paper elevation={1} sx={{
                    p: 1.5,
                    border: '1px solid',
                    bgcolor: 'trasparent',
                    borderRadius: '12px 12px 12px 0px',
                    borderColor: 'secondary.main',
                    color: 'primary.contrastText',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: '40px',
                    boxSizing: 'border-box'
                }}>
                    <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center', height: '8px', px: 0.5 }}>
                        <Typography sx={{fontSize: CHAT_FONT}}>{thinkingText}</Typography>
                        <Box sx={{ width: dotsDimension, height: dotsDimension, bgcolor: 'currentColor', borderRadius: '50%', animation: `${bounce} 1.4s infinite ease-in-out`, animationDelay: '0s' }} />
                        <Box sx={{ width: dotsDimension, height: dotsDimension, bgcolor: 'currentColor', borderRadius: '50%', animation: `${bounce} 1.4s infinite ease-in-out`, animationDelay: '0.2s' }} />
                        <Box sx={{ width: dotsDimension, height: dotsDimension, bgcolor: 'currentColor', borderRadius: '50%', animation: `${bounce} 1.4s infinite ease-in-out`, animationDelay: '0.4s' }} />
                    </Box>
                </Paper>
            </Box>
        </Box>
    );
};